import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import AudienceSegment from './components/AudienceSegment';
import ServicesOverview from './components/ServicesOverview';
import AIAnswerBlock from './components/AIAnswerBlock';
import Process from './components/Process';
import WhyChooseUs from './components/WhyChooseUs';
import ServiceAreas from './components/ServiceAreas';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';

const HomePage = () => {
  return (
    <main>
      <Hero />
      <TrustBar />
      <AudienceSegment />
      <ServicesOverview />
      <AIAnswerBlock />
      <Process />
      <WhyChooseUs />
      <ServiceAreas />
      <Testimonials />
      <FAQ />
      <FinalCTA />
    </main>
  );
};

export default HomePage;
